import {
  LayoutGrid,
  BookOpen,
  Package,
  FileText,
  GraduationCap,
  Users,
  CreditCard,
  Ticket,
  BarChart2,
  Layout,
  Shield,
  Lock,
  Tag,
  Wallet,
  Sliders,
  Share2,
  Settings2,
  MessageSquare,
  Send,
  ListOrdered,
  type LucideIcon,
} from "lucide-react";

export interface RouteConfig {
  path: string;
  label: string;
  icon: LucideIcon;
  breadcrumb: string;
  section?: "main" | "content" | "financial" | "settings" | "security" | "marketing";
  permission?: string;
}

export const routes: RouteConfig[] = [
  // Main Section - Overview & People
  {
    path: "/dashboard",
    label: "Dashboard",
    icon: LayoutGrid,
    breadcrumb: "Dashboard",
    section: "main",
    // Public access
  },
  {
    path: "/students",
    label: "Students",
    icon: GraduationCap,
    breadcrumb: "Students",
    section: "main",
    permission: "users:read",
  },
  {
    path: "/instructors",
    label: "Instructors",
    icon: Users,
    breadcrumb: "Instructors",
    section: "main",
    permission: "instructors:read",
  },
  {
    path: "/analytics",
    label: "Analytics",
    icon: BarChart2,
    breadcrumb: "Analytics",
    section: "main",
    permission: "analytics:read",
  },

  // Content Section - Learning Materials
  {
    path: "/courses",
    label: "Courses",
    icon: BookOpen,
    breadcrumb: "Courses",
    section: "content",
    permission: "courses:read",
  },
  {
    path: "/packages",
    label: "Packages",
    icon: Package,
    breadcrumb: "Packages",
    section: "content",
    permission: "packages:read",
  },
  {
    path: "/exams",
    label: "Exams",
    icon: FileText,
    breadcrumb: "Exams",
    section: "content",
    permission: "quizzes:read",
  },
  {
    path: "/trades",
    label: "Trades",
    icon: Tag,
    breadcrumb: "Trades",
    section: "content",
    permission: "trades:read",
  },
  {
    path: "/reviews",
    label: "Reviews",
    icon: MessageSquare,
    breadcrumb: "Reviews",
    section: "content",
    permission: "reviews:read",
  },
  {
    path: "/discussions",
    label: "Discussions",
    icon: MessageSquare,
    breadcrumb: "Discussions",
    section: "content",
    permission: "discussions:read",
  },
  {
    path: "/blogs",
    label: "Blogs",
    icon: FileText,
    breadcrumb: "Blogs",
    section: "content",
    permission: "blogs:read",
  },

  // Financial Section - Payments & Revenue
  {
    path: "/enrollments",
    label: "Enrollments",
    icon: CreditCard,
    breadcrumb: "Enrollments",
    section: "financial",
    permission: "enrollments:read",
  },
  {
    path: "/payments",
    label: "Payments",
    icon: Wallet,
    breadcrumb: "Payments",
    section: "financial",
    permission: "payments:read",
  },
  {
    path: "/orders",
    label: "Orders",
    icon: ListOrdered,
    breadcrumb: "Orders",
    section: "financial",
    permission: "orders:read",
  },
  {
    path: "/coupons",
    label: "Coupons",
    icon: Ticket,
    breadcrumb: "Coupons",
    section: "financial",
    permission: "coupons:read",
  },

  // Marketing Section - Email Campaigns
  {
    path: "/email-campaigns",
    label: "Email Campaigns",
    icon: Send,
    breadcrumb: "Email Campaigns",
    section: "marketing",
    permission: "campaigns:read",
  },

  // Settings Section - Configuration
  {
    path: "/pages",
    label: "Pages",
    icon: Layout,
    breadcrumb: "Pages",
    section: "settings",
    permission: "settings:read",
  },
  {
    path: "/slider",
    label: "Slider",
    icon: Sliders,
    breadcrumb: "Slider Management",
    section: "settings",
    permission: "content:manage-slider",
  },
  {
    path: "/social-links",
    label: "Social Links",
    icon: Share2,
    breadcrumb: "Social Links",
    section: "settings",
    permission: "social-links:read",
  },
  {
    path: "/global-changes",
    label: "Global Changes",
    icon: Settings2,
    breadcrumb: "Global Changes",
    section: "settings",
    permission: "globalChanges:read",
  },

  // Security Section - Access Control
  {
    path: "/admins",
    label: "Admins",
    icon: Shield,
    breadcrumb: "Admins",
    section: "security",
    permission: "admin:read",
  },
  {
    path: "/authentication",
    label: "Authentication",
    icon: Lock,
    breadcrumb: "Authentication",
    section: "security",
    permission: "settings:update",
  },
];

export const getRouteByPath = (pathname: string): RouteConfig | undefined => {
  return routes.find((route) => pathname.startsWith(route.path));
};
